export const FISHYMAP_ZONE_CATALOG_READY_EVENT = "fishymap:zone-catalog-ready";

function cloneJson(value) {
  return JSON.parse(JSON.stringify(value));
}

export function dispatchShellZoneCatalogReadyEvent(
  shell,
  zoneCatalog,
  customEventConstructor = globalThis.CustomEvent,
) {
  if (
    !shell ||
    typeof shell.dispatchEvent !== "function" ||
    typeof customEventConstructor !== "function"
  ) {
    return false;
  }
  const clonedCatalog = Array.isArray(zoneCatalog) ? cloneJson(zoneCatalog) : [];
  shell.fishyMapZoneCatalog = clonedCatalog;
  shell.dispatchEvent(
    new customEventConstructor(FISHYMAP_ZONE_CATALOG_READY_EVENT, {
      bubbles: true,
      detail: {
        zoneCatalog: cloneJson(clonedCatalog),
      },
    }),
  );
  return true;
}
